import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../components/common';
import { UploadStatus } from '../../../../utils/hooks/useFilesUploader/types';
import { IOuter } from './UploadingFileStatus.types';

export const UploadingFileStatus: FC<IOuter> = ({ className, status, readableFileSize }) => {
  const statusText =
    status === UploadStatus.Waiting ? (
      <FormattedMessage id="uploading-file.status.pending" />
    ) : status === UploadStatus.Processing || status === UploadStatus.Uploading ? (
      readableFileSize ? (
        readableFileSize
      ) : (
        <FormattedMessage id="uploading-file.status.uploading-without-file-size" />
      )
    ) : status === UploadStatus.Succeeded ? (
      readableFileSize ? (
        readableFileSize
      ) : null
    ) : null;

  if (!statusText) {
    return null;
  }

  return (
    <Text className={className} light secondary size="small" dataHook={`uploading-file-status-${status}`}>
      {statusText}
    </Text>
  );
};
